import { useQuery } from "@tanstack/react-query";

import { getSkindropIsVisibleOnMarketplace } from "api/methods";

import { usePlatform } from "./usePlatform";

export interface SkinDropVisibility {
  isSkinDropEnabled: boolean;
  isSkinDropVisibleOnMarketplace: boolean | undefined;
  isSkinDropVisible: boolean;
  isSkinDropLoading: boolean;
}

export const useSkinDropVisibility = (): SkinDropVisibility => {
  const { platform } = usePlatform();

  const { data: isSkinDropVisibleOnMarketplace, isPending: isSkinDropLoading } = useQuery({
    ...getSkindropIsVisibleOnMarketplace.keyed(),
    staleTime: 1000 * 10,
  });

  const isSkinDropEnabled = !!platform?.platformSettings?.skinDropEnabled;

  return {
    isSkinDropEnabled,
    isSkinDropVisibleOnMarketplace,
    isSkinDropVisible: isSkinDropEnabled && !!isSkinDropVisibleOnMarketplace,
    isSkinDropLoading,
  };
};
